import * as React from 'react'
import { withStatus } from '../status'
import { withFields } from '../fields'
import { replace } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import navigationActions from './navigation-actions'


/*

Handles navigation related functionality, such as route changing, back button prevention, route disablements,
and a warning when the user is about to close the form in an unsaved state. See actions.

*/


function mapStateToProps(state, intialProps){
    return {
        ...intialProps,
        navigation: state.navigation
    }
}


function mapDispatchToProps(dispatch, props){
    return {
        actions:{
            ...props.actions,
            navigation: bindActionCreators(navigationActions, dispatch)
        }
    }
}


export const withNavigation = (Wrapped:React.ComponentClass) => connect(mapStateToProps, mapDispatchToProps)(Wrapped)








// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/navigation/index.tsx